module.exports = __webpack_public_path__ + "img/pleion-avatar.f79662c6.png";